var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"c-echarts-pip"},[(_vm.ecData.length)?_c('pie-echart',{attrs:{"config-options":_vm.echartsOptions}}):_c('no-data')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }